import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getConfig(params = {}) {
    return get(config.BASE_URL, config.getConfigUrl, params)
}

export function updateConfig(params = {}, configParams = {}) {
    return post(config.BASE_URL, config.updateConfigUrl, params, configParams)
}